export const patient = {
  state: {},
  reducers: {
    update(state, patientData) {
      return Object.assign({}, state, patientData);
    },
  },
  effects: {
    setPatient(patient, rootState) {
      this.update(patient);
    },
  },
};
